import * as React from 'react';
import classnames from 'classnames';

import Spinner from 'components/spinner/Spinner';

import './campaign-pie-widget.scss';

type Props = {
  title: string,
  total: string,
  content: React.ReactNode,
  table?: React.ReactNode,
  disclaimer?: React.ReactNode,
  tablePosition?: 'static' | 'absolute',
  hasOnlyOneMetric?: boolean,
  hideTotal?: boolean,
  isPieCentered?: boolean,
  isLoading: boolean
};

class CampaignPieWidget extends React.Component<Props> {
  static defaultProps = {
    isPieCentered: true
  };

  renderSpinner(): JSX.Element {
    return (
      <div className="campaign-pie-widget__spinner">
        <Spinner
          position="inline"
          size="small"
          color="light"
        />
      </div>
    );
  }

  renderContent(): React.ReactNode {
    const { hasOnlyOneMetric, content, table, tablePosition } = this.props;

    const tableClasses = classnames('campaign-pie-widget__table', {
      'campaign-pie-widget__table--single': hasOnlyOneMetric,
      [`campaign-pie-widget__table--${tablePosition}`]: tablePosition
    });

    return (
      <React.Fragment>
        <div className="campaign-pie-widget__info">
          {content}
        </div>
        {
          Boolean(table) && (
            <div className={tableClasses}>
              {table}
            </div>
          )
        }
      </React.Fragment>
    );
  }

  render() {
    const { disclaimer, title, total, hideTotal, isLoading, isPieCentered } = this.props;

    const headerClasses = classnames('campaign-pie-widget__header', {
      'campaign-pie-widget__header--no-total': hideTotal
    });

    const contentClasses = classnames('campaign-pie-widget__content', {
      'campaign-pie-widget__content--pie-not-centered': !isPieCentered
    });

    return (
      <div className="campaign-pie-widget">
        { isLoading && this.renderSpinner() }
        <div className={headerClasses}>
          <div className="campaign-pie-widget__title">
            {title}
          </div>
          {
            !hideTotal && (
              <div className="campaign-pie-widget__metric">
                {total}
              </div>
            )
          }
          { disclaimer }
        </div>
        {
          !isLoading && (
            <div className={contentClasses}>
              {this.renderContent()}
            </div>
          )
        }
      </div>
    );
  }
}

export default CampaignPieWidget;
